import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueDateEarlierThanIssuedReceiptError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.issue-date.earlier-than-issued-receipt');
    }
}
